import { useState, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import Carousel from "../Components/Carousel/Carousel";
import BreathingBox from "../Components/BreathBox/BreathingBox";
import { useParams } from "react-router-dom";
import Pages from "./Pages";
import { useAuthContext } from "../context/AuthContext";
import { API } from "../constant";
import { authFetch } from "../helpers";
import Header from "../Components/Header/Header";
import LoadingImg from "../Media/loading.gif";
import HTMLReactParser from "html-react-parser/lib/index";
import Parser from 'html-react-parser';
import { getToken } from "../helpers";
import SkillItem from "../Components/Skills/SkillItem";
import { Link } from "react-router-dom";
import CustomSkills from "../Components/Skills/CustomSkills";
import AssessmentQuiz from "./AssessmentQuiz";
import Quiz from "./Quiz";
import Tipps from "./Tipps";

const StopSkill =() => {

    const param  = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [carouselItems, setCarouselItem] = useState([]);
    const [templete, settemplete] = useState([]);
    const[content, setcontent] = useState([]);
    const[skillId, setSkillId] = useState();
    const[start, setStart] = useState(0);
    const[skillImage, setSkillImage] = useState();
    const[pageTitle, setPageTitle] = useState();
    const[introUpdate, setIntroUpdate] = useState();
    const[lastItem, setLastItem] =useState(false); 
    const[d_comp, setDComp]=useState();
    const[customSkillsFirst, setCustomSkillsFirst] = useState();
    const[customSkillsLast, setCustomSkillsLast] = useState();
   
    // const[hideIntro, setHideIntro] = useState(false);

    const { user } = useAuthContext();
    let userName;
    let userId;
    if(user !==undefined){
    userName = user.username;
    userId = user.id;
    }
  // console.log(userId);
    const handleLastItem = (dataFromCarousel) => {
      setLastItem(dataFromCarousel); 
    };
    useEffect(() => {
      setLoading(true);
      authFetch(`${API}/skills?filters[slug][$eq]=${param.slug}&populate[skill_step][populate]=image&populate[Skill_Image]=*&populate[user_hide_intro]=*&populate[custom_skills_first]=*&populate[custom_skills_last]=*&populate[desc_img]=*&populate[triggers]=*&populate[dc][on][skills.assessment-quiz][populate]=*&populate[dc][on][skills.quiz][populate]=*&populate[dc][on][skills.tips][populate]=*`)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          // console.log(data)
          setCarouselItem(data.data[0].attributes.skill_step);
          settemplete(data.data[0].attributes.skill_templates);
          settemplete(data.data[0].attributes.skill_templates);
          setcontent(data.data[0].attributes);
          const img =data.data[0].attributes.desc_img.data;
          setSkillImage(img?img.attributes.url:"#");
          const title =data.data[0].attributes.Title;
          setPageTitle(title?title:"");

          const custom_skill_first_data=data.data[0].attributes.custom_skills_first.data;
          const custom_skill_last_data=data.data[0].attributes.custom_skills_last.data;
          console.log(data.data);
          let fs=[];
          if(custom_skill_first_data.length>0){
            custom_skill_first_data.filter((item, index)=>{
            return fs[index]=item.id;
          })} 
          setCustomSkillsFirst(fs);
          let ls=[];
          if(custom_skill_last_data.length>0){
            custom_skill_last_data.filter((item, index)=>{
            return ls[index]=item.id;
          })} 
          setCustomSkillsLast(ls);
          const dc = data.data[0].attributes.dc.length>0?data.data[0].attributes.dc[0].__component:"";
          // console.log(dc);
          if(dc!==null){
          setDComp(dc);
          }
          // console.log(dc);
          setSkillId(data.data[0].id);
          const dataUsers = data.data[0].attributes.user_hide_intro.data;
          dataUsers.map((item)=>{
            if(item.id === userId){
              // setHideIntro(true);
              setStart(1);
            }
          })
          // console.log(data);
          setLoading(false);
          // setSkillImage(dat
          // a.data[0].attributes);
          // console.log(data);
        })
        .catch((err) => {
          console.error("Error fetching skill:", err);
          setLoading(false);
        });
    }, [param, userId]);

    function renderSwitch(x){
      switch (x) {
        case 'skills.assessment-quiz':
          return <AssessmentQuiz Content = {content} Slug={param.slug} SkillId={skillId}/> 
        case 'skills.quiz':
          return <Quiz Content = {content} Slug={param.slug} SkillId={skillId}/>
        case 'skills.tips':
          return <Tipps Content = {content} Slug={param.slug} SkillId={skillId}/> 
        case 'box_breathing':
          return <BreathingBox SkillId ={skillId} onDataSend={handleLastItem} Slug={param.slug}/>;
        default:
          // return <Carousel Items = {carouselItems} SkillId ={skillId} onDataSend={handleLastItem}/>;
        }
      }

    if(introUpdate && start ){
      fetch(`${API}/users/${user.id}?populate=*`)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          let hide =[];
          data.hide_intro.map((item, index)=>{
              hide[index] = {id:item.id}
          })
          hide.push({id: skillId});
          const userResponse = fetch(`${API}/users/${user.id}`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                // set the auth token to the user's jwt
                Authorization: `Bearer ${getToken()}`,
              },
              body: JSON.stringify(
                {  
                    
                    hide_intro: hide
                }
              ),
            });
            if(userResponse){
              console.log("Data added successfully")
            }
          
        });
    };

    return  param.slug==="box-breathing"?<BreathingBox SkillId ={skillId}/>:renderSwitch(d_comp);
    
}
export default StopSkill;